import { Injectable, inject } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AppInitializerService } from '@simac/ui';

@Injectable({
  providedIn: 'root',
})
export class AiService {
  private readonly initializerService = inject(AppInitializerService);

  setUpApplicationInsights(): void {
    const connectionString = this.initializerService.getAiConnectionString();
    if (!connectionString) {
      return;
    }
    const appInsights = new ApplicationInsights({
      config: {
        extensionConfig: {
          ['AppInsightsCfgSyncPlugin']: {
            cfgUrl: '', // this will block fetching from default cdn causing CSP errors. https://github.com/microsoft/ApplicationInsights-JS/issues/2341
          },
        },
        connectionString,
        disableExceptionTracking: true,
        autoTrackPageVisitTime: true,
        enableAutoRouteTracking: true,
        maxAjaxCallsPerView: -1, // this will track all ajax calls, otherwise receive error in app insights over 500 ajax calls
      },
    });
    appInsights.loadAppInsights();
    appInsights.trackPageView();
  }
}
